export const navLinksLogIn = [
  { link: "/", name: "Home" },
  { link: "/badges", name: "Our System" },
  { link: "/companies", name: "Companies" },
  { link: "/about", name: "About Us" },
  { link: "/sign-up", name: "Sign Up" },
  { link: "/login", name: "Logout" },
];
